import { Box } from '@mui/material';
import Grid2 from '@thirdparty-framework/mui/material/Grid';
import {
  Breadcrumb,
  useLocalization,
  useUserAccess,
} from '@ui-framework/index';
import { observer } from 'mobx-react';

import { useNavigate } from 'react-router-dom';
import {
  ArrowTab,
  ArrowTabGroup,
  CustomTabPanel,
  IconLibrary,
  Layout,
  StackablePageButtons,
} from '@product-framework/index';
import ServiceProviderBasicInfoCreate from '../../components/CompanyInfo/create';
import StepperTabsConfig from '../../components/StepperTabsConfig';

function ServiceProviderCreate() {
  const { formatMessage } = useLocalization();
  const navigate = useNavigate();
  const userAccess = useUserAccess();

  const stepperTabs = StepperTabsConfig({ userAccess, formatMessage });

  const breadCrumb = [
    {
      name: formatMessage({
        id: 'DASHBOARD_BREADCRUMB',
        defaultMessage: 'Dashboard',
      }),
      icon: IconLibrary.Dashboard,
      onClick: () => {
        navigate('/dashboard');
      },
    },
    {
      name: formatMessage({
        id: 'SERVICEPROVIDERS_BREADCRUMB',
        defaultMessage: 'Service Providers',
      }),
      icon: IconLibrary.ServiceProviders,
      permissionName: 'CAN_LIST_SP',
      onClick: () => {
        navigate('/serviceproviders');
      },
    },
    {
      name: formatMessage({
        id: 'CREATE_SERVICEPROVIDER_BREADCRUMB',
        defaultMessage: 'Create Service Provider',
      }),
      icon: IconLibrary.ServiceProvider,
      onClick: undefined,
    },
  ];

  const stackablePageButtons = [
    {
      label: formatMessage({
        id: 'EDIT_SERVICEPROVIDERS_STACKABLE_BUTTON',
        defaultMessage: 'List Service Providers',
      }),
      permissionName: 'CAN_LIST_SP',
      Icon: IconLibrary.ServiceProviders,
      variant: 'outlined',
      onClick: () => navigate('/serviceproviders'),
    },
  ];

  return (
    <Layout>
      <Grid2 xs={12} container>
        <Grid2 xs={12} md={6}>
          <Breadcrumb items={breadCrumb} />
        </Grid2>
        <Grid2 xs={12} md={6}>
          <StackablePageButtons buttons={stackablePageButtons} />
        </Grid2>
      </Grid2>
      <Grid2 xs={12}>
        <Box>
          <ArrowTabGroup value={0} onChange={() => {}}>
            {stepperTabs.map(stepper => {
              return (
                <ArrowTab
                  key={stepper.label}
                  maxTabs={stepperTabs.length}
                  label={stepper.label}
                  config={stepper}
                />
              );
            })}
          </ArrowTabGroup>
        </Box>
      </Grid2>
      <Grid2 xs={12}>
        <CustomTabPanel value={0} index={0}>
          <ServiceProviderBasicInfoCreate />
        </CustomTabPanel>
      </Grid2>
    </Layout>
  );
}

export default observer(ServiceProviderCreate);
